// extracted by mini-css-extract-plugin
export default {"container":"CustomLink_container__peCFz","primary":"CustomLink_primary__hrLe5"};